
<form [formGroup]="gruppForm">
    <div class="modal-body">
        <div class="row">
            <rask-input
                aid="inputGruppNamn"
                label="Namn på gruppen av frågor"
                formControlName="gruppNamn"
                [required]="true">
            </rask-input>
        </div>
    </div>
    <div class="modal-footer">
        <rask-save-button [disabled]="!canSave()" (click)="onSave()">Spara</rask-save-button>
        <rask-button aid="buttonAvbryt" (click)="onCancel()" color="secondary">Avbryt</rask-button>
    </div>
</form>